export const RESERVE_GET_SERVICE_NUMBERS_REQUEST = 'RESERVE_GET_SERVICE_NUMBERS_REQUEST';
export const RESERVE_GET_SERVICE_NUMBERS_SUCCESS = 'RESERVE_GET_SERVICE_NUMBERS_SUCCESS';
export const RESERVE_GET_SERVICE_NUMBERS_ERROR = 'RESERVE_GET_SERVICE_NUMBERS_ERROR';

export const ADD_RESERVE_SERVICE_NUMBERS_REQUEST = 'ADD_RESERVE_SERVICE_NUMBERS_REQUEST';
export const ADD_RESERVE_SERVICE_NUMBERS_SUCCESS = 'ADD_RESERVE_SERVICE_NUMBERS_SUCCESS';
export const ADD_RESERVE_SERVICE_NUMBERS_ERROR = 'ADD_RESERVE_SERVICE_NUMBERS_ERROR';

export const GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST = 'GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST';
export const GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS = 'GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS';
export const GET_UN_RESERVED_SERVICE_NUMBERS_ERROR = 'GET_UN_RESERVED_SERVICE_NUMBERS_ERROR';

export const REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST = 'REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST';
export const REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS = 'REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS';
export const REMOVE_RESERVE_SERVICE_NUMBERS_ERROR = 'REMOVE_RESERVE_SERVICE_NUMBERS_ERROR';

export const GET_NEW_LINE_RESERVED_NUMBERS_REQUEST = 'GET_NEW_LINE_RESERVED_NUMBERS_REQUEST';
export const GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS = 'GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS';
export const GET_NEW_LINE_RESERVED_NUMBERS_ERROR = 'GET_NEW_LINE_RESERVED_NUMBERS_ERROR';
export const GET_CLEAR_SERVICE_NUMBER = 'GET_CLEAR_SERVICE_NUMBER';

export const IS_RESERVE_NUMBERS_SELECTED = 'IS_RESERVE_NUMBERS_SELECTED';
